(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[648],{

/***/ 4346:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Index; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(682);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(4012);
// EXTERNAL MODULE: ./src/components/shared/breadCrumb/styles/styles.module.scss
var styles_module = __webpack_require__(6962);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/shared/breadCrumb/assets/breadCrumb.avif
/* harmony default export */ var breadCrumb = ({"src":"/_next/static/media/breadCrumb.aff9d432.avif","height":1330,"width":2000,"blurDataURL":"data:image/avif;base64,AAAAHGZ0eXBhdmlmAAAAAG1pZjFhdmlmbWlhZgAAAXBtZXRhAAAAAAAAACFoZGxyAAAAAAAAAABwaWN0AAAAAAAAAAAAAAAAAAAAAA5waXRtAAAAAAABAAAANGlsb2MAAAAAREAAAgABAAAAAAGUAAEAAAAAAAAATwACAAAAAAHjAAEAAAAAAAAAFQAAADhpaW5mAAAAAAACAAAAFWluZmUCAAAAAAEAAGF2MDEAAAAAFWluZmUCAAAAAAIAAGF2MDEAAAAAr2lwcnAAAACKaXBjbwAAAAxhdjFDgSACAAAAABRpc3BlAAAAAAAAAAgAAAAFAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQAcAAAAAA5waXhpAAAAAAEIAAAAOGF1eEMAAAAAdXJuOm1wZWc6bXBlZ0I6Y2ljcDpzeXN0ZW1zOmF1eGlsaWFyeTphbHBoYQAAAAAdaXBtYQAAAAAAAAACAAEDgQIDAAIEhAIFhgAAABppcmVmAAAAAAAAAA5hdXhsAAIAAQABAAAAbG1kYXQSAAoIOAi8YQENBpAyQRTAAABQqEVlZka/Msh/reC4VnUKNzTWMxH5mLGkhcrFORQnQ2II1O05fqzWbykXkMdGLA/rXmxorUD2MsXhlSGAEgAKBRgIvGFQMgoUwAABAAF1UKUo","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./src/components/shared/breadCrumb/assets/works_breadcrumb.jpg
/* harmony default export */ var works_breadcrumb = ({"src":"/_next/static/media/works_breadcrumb.537d82bb.jpg","height":200,"width":1700,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAABAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAYEAEAAwEAAAAAAAAAAAAAAAAAAQIzcf/EABUBAQEAAAAAAAAAAAAAAAAAAAME/8QAFxEAAwEAAAAAAAAAAAAAAAAAAAIxAf/aAAwDAQACEQMRAD8AhYwtwA7UnWYf/9k=","blurWidth":8,"blurHeight":1});
;// CONCATENATED MODULE: ./src/components/shared/breadCrumb/assets/servics_breadcrumb.jpg
/* harmony default export */ var servics_breadcrumb = ({"src":"/_next/static/media/servics_breadcrumb.406428d8.jpg","height":200,"width":1700,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAABAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAZEAEAAgMAAAAAAAAAAAAAAAAAAgMzcsL/xAAUAQEAAAAAAAAAAAAAAAAAAAAD/8QAFREBAQAAAAAAAAAAAAAAAAAAAAH/2gAMAwEAAhEDEQA/AIivNHToAkHX/9k=","blurWidth":8,"blurHeight":1});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./src/components/shared/breadCrumb/Index.js












var BreadCrumb = function BreadCrumb(_ref) {
  var title = _ref.title;
  var router = (0,next_router.useRouter)();
  var locale = router.locale;
  var isRtl = locale === "ar";
  var isServicesPage = router.pathname === "/services";
  var isWorksPage = router.pathname === "/ourworks" || router.pathname === "/blogs" || router.pathname === "/blogs/[slug]";
  var backgroundImage = isServicesPage ? servics_breadcrumb : isWorksPage ? works_breadcrumb : breadCrumb;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (styles_module_default()).breads,
    dir: locale === "ar" ? "rtl" : "ltr",
    style: {
      backgroundImage: "url(".concat(backgroundImage.src || backgroundImage, ")")
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Container["default"], {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (styles_module_default()).breads__inner,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (styles_module_default()).breads__content,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
            children: title
          }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "/contactus",
            passHref: true,
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
              className: (styles_module_default())["cta-button-red"],
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                id: "contact-us"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (styles_module_default())["icon-circle"],
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
                  style: {
                    transform: isRtl ? "none" : "scaleX(-1)"
                  },
                  width: "18",
                  height: "18",
                  viewBox: "0 0 18 18",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                    d: "M3.53577 3.53556L14.1424 14.1422",
                    stroke: "black",
                    strokeWidth: 1.5,
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                    d: "M3.53553 10.6066L3.53553 3.53553L10.6066 3.53553",
                    stroke: "black",
                    strokeWidth: 1.5,
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                  })]
                })
              })]
            })
          })]
        })
      })
    })
  });
};

/* harmony default export */ var Index = (BreadCrumb);

/***/ }),

/***/ 6962:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"breads":"styles_breads__eY1Zd","breads__inner":"styles_breads__inner__WYN36","breads__content":"styles_breads__content__i7wfq","cta-button-red":"styles_cta-button-red__Oa5fB","icon-circle":"styles_icon-circle__VDLuX"};

/***/ })

}]);